import { find, map } from 'lodash'
import { AddonData } from '../apis/addon.api'

export default {
  selectOptions (addons: AddonData[]) {
    return map(addons, addon => {
      const { name, id } = addon
      return { name, value: String(id) }
    })
  },

  find (addons: AddonData[], id: number) {
    return find(addons, { id })
  }
}
